import NextLink from "next/link";
import React from "react";
import { Heading, Text } from "ui-components";

export default function CustomerSuccessManager({
  name,
  email,
  phone,
}: {
  name: string;
  email: string;
  phone: string;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-y-5">
      <Heading variant="h2" align="center">
        Your Customer Success Manager
      </Heading>
      <div className="flex flex-col bg-background-dark bg-opacity-20 rounded-large p-5 items-center justify-center text-center gap-y-5">
        <Heading variant="h3" align="center">
          {name}
        </Heading>
        <Text>
          I’m your Customer Success Manager. Please let me know if I can help
          you.
        </Text>
        <p>
          <NextLink
            href={`mailto:${email}`}
            target="_blank"
            className="underline"
          >
            <Text>Email me: {email}</Text>
          </NextLink>
        </p>
        {phone && (
          <p>
            <NextLink
              href={`tel:${phone.replace("++", "+")}`}
              className="underline"
            >
              <Text>Call me at: {phone.replace("++", "+")}</Text>
            </NextLink>
          </p>
        )}
      </div>
    </div>
  );
}
